import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useForm, Controller } from 'react-hook-form'
import { Box, Grid, TextField } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import schema from './schema'

const AddInviteAdvisor = ({
  onSubmit,
  disabled,
  setDisabled,
  invite,
  buttonClick,
  setButtonClick,
}) => {
  const { control, handleSubmit, errors } = useForm({
    validationSchema: schema,
    defaultValues: {
      email: invite?.email ?? '',
    },
  })

  useEffect(() => {
    if (disabled) setDisabled(false)
    //eslint-disable-next-line
  }, [disabled])

  useEffect(() => {
    if (buttonClick) {
      handleSubmit(onSubmit)()
      setButtonClick(false)
    }
    // eslint-disable-next-line
  }, [buttonClick])

  return (
    <Box my={2} component="form">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Alert severity="warning">
            Esta ação arquivará automaticamente os projetos de governança
            vinculados ao grupo advisor de origem.
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                label="Email"
                type="email"
                color="primary"
                variant="outlined"
                error={!!errors.email}
                helperText={errors?.email?.message}
                fullWidth
              />
            }
            control={control}
            name="email"
            mode="onBlur"
          />
        </Grid>
      </Grid>
    </Box>
  )
}

AddInviteAdvisor.propTypes = {
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
  setDisabled: PropTypes.func,
  invite: PropTypes.object,
  buttonClick: PropTypes.func,
  setButtonClick: PropTypes.func,
}

AddInviteAdvisor.defaultProps = {
  onSubmit: () => {},
  setDisabled: () => {},
  invite: {},
  buttonClick: () => {},
  setButtonClick: () => {},
}

export default AddInviteAdvisor
